<template>
  <div class="wraper">
    <el-row class='top'>
      <span>设备分组</span>
      <el-tooltip placement="right">
        <div slot="content">
          分组报表：以分组为维度，把不同渠道、大区、省区/分公司、冷柜系列、渠道类型、二级渠道、三级渠道、
          <br>经销商、客户类型、网点、省份、城市、投放政策下的设备放入同一分组，统一查看管理。
          <br>累计客流：分组内所有大数据冷柜客流量总和(开关门次数-补货次数)
          <br>平均日客流：分组内平均每台设备每天客流量
          <br>平均纯净度：分组内所有大数据冷柜纯净度平均值
          <br>累计销售额：分组内所有大数据冷柜销售额量总和(排除补货、退货状态后，各商品销售数量*对应单价后金额总和)
          <br>平均销售额：分组内平均每台设备每天额销售额
          <br>累计销量：分组内所有大数据冷柜销量总和(排除补货、退货状态后，各商品销售数量总和）
          <br> 平均销量：分组内平均每台设备每天的销售额
        </div>
        <i class="el-icon-question"></i>
      </el-tooltip>
      <el-button size="mini" type="primary" @click="handleAddGroup">新增设备分组</el-button>
      <el-dialog title="新增设备分组" :visible.sync="AddGroupVisible" center width="30%">
        <el-form :model="addform">
          <el-form-item label="设备分组名称" label-width="100px">
            <el-input v-model="addform.groupName" style="width:220px"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clearForm">取 消</el-button>
          <el-button type="primary" @click="addGroup">确 定</el-button>
        </div>
      </el-dialog>
      <el-input
        v-model="search"
        size="mini"
        placeholder="请输入设备分组名称搜索内容"
        clearable
        class='search'
        @keyup.enter.native="searchTable"
      ></el-input>
      <el-button size="mini" type="primary" @click='searchTable'>查询</el-button>
      <div class="export_btn">
        <exporter
          :setting='setting'
          :url='getListUrl'
          :date='date'
          :exportName="exportName"
        ></exporter>
      </div>
    </el-row>
    <!-- <deviceSearchBox @getSearchSelect="searchTable"></deviceSearchBox> -->
    <el-row>
      <report
        :setting='setting'
        :list='list'
        @freshList='handleSun'
        @changeSort="changeSort"
      ></report>
      <el-row class="pages">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>
  </div>
</template>

<script>
    import Report from '../../components/Report'
    import exporter from '../../components/exporter'

    export default {
        name: 'reports',
        components: {
            Report,
            exporter
        },
        data() {
            return {
                exportName:'设备分组报表',
                getListUrl: 'data/getDeviceManagement_GroupList',
                addGroupUrl: 'data/addGroup',
                date: [],
                currentPage: 1,
                list: [],
                total: 0,
                pageSize: 10,
                search: '',
                setting: {
                    isShowSelect: false,
                    isShowIndex: false,
                    tHeader: [{
                        dataItem: 'groupName',
                        dataName: '设备分组名称'
                    }, {
                        dataItem: 'putAssetsNum',
                        dataName: '投放设备数量'
                    }, {
                        dataItem: 'sumCustomerFlow',
                        dataName: '累计客流统计'
                    }, {
                        dataItem: 'avgPurity',
                        dataName: '平均专放率'
                    }, {
                        dataItem: 'sumSalesAmount',
                        dataName: '累计销售统计'
                    }],
                    isShowPlay: true,
                    isShowDelBtn: true,
                    isShowAddBtn: true,
                    isShowEditBtn: true,
                    isShowAssetsDetailBtn: true,
                    btnsWidth: '420px',
                    infoUrl: 'devicesDetail'
                },
                AddGroupVisible: false,
                addform: {
                    groupName: ''
                }
            }
        },
        mounted() {
            this.getList()
        },
        methods: {
            searchTable() {
                this.getList();
            },
            getList(val) {
                let url = this.getListUrl;
                let params = {
                    startDay: this.date[0],
                    endDay: this.date[1],
                    pageSize: this.pageSize,
                    pageNum: this.currentPage,
                    keyWord: this.search
                }
                if(val!=undefined){
                    params.order = val.order;
                    params.prop  =  val.prop;
                }
                let _this = this;
                this.$ajax.post(url, params)
                    .then(this.getListSucc)
                    .catch(function (res) {
                        _this.$message.error('哎呀~网络异常了呢');
                    })
            },
            getListSucc(res) {
                if (res.data && res.data.code === 200) {
                    const data = res.data.data
                    this.list = data.list
                    this.list.forEach((item, index) => {
                      switch (item.onlineStatus) {
                        case 0:
                          item.onlineStatus = '离线'
                          break;
                        // eslint-disable-next-line no-fallthrough
                        case 1:
                          item.onlineStatus = '在线'
                          break;
                        default:
                          break;
                      }

                    })
                  this.total = data.total
                }  else {
                    let errMsg = '未知错误'
                    if (res.data.msg) {
                        errMsg = res.data.msg;
                    }
                    this.$message.error(errMsg);
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.currentPage = 1;
                this.getList()
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getList()
            },
            handleSun() {
                this.currentPage = 1;
                this.getList()
            },
            handleAddGroup() {
                this.AddGroupVisible = true;
            },
            clearForm() {
                this.addform.groupName = ''
                this.AddGroupVisible = false

            },
            addGroup() {
                let url = this.addGroupUrl;
                let params = {
                    groupName: this.addform.groupName
                }
                let _this = this;
                this.$ajax.post(url, params)
                    .then(function (res) {
                        if (res.data && res.data.code === 200) {
                            _this.currentPage = 1;
                            _this.getList();
                            _this.AddGroupVisible = false;
                        } else {
                            let errMsg = '未知错误'
                            if (res.data.msg) {
                                errMsg = res.data.msg;
                            }
                            _this.$message.error(errMsg);
                        }
                    })
                    .catch(function (res) {
                        _this.$message.error('哎呀~网络异常了呢');
                    })
            },
            changeSort(val) {
                this.getList(val)
            }
        }
    }
</script>
<style scoped>
  .top {
    height: 50px;
  }

  .pages {
    padding-top: 10px;
    text-align: center;
  }

  .search {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/devices/devices.vue